import {
  Button,
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@features/ui';
import { formatDate } from '@lib/utils';
import { Affiliate } from '@src/types';
import React from 'react';
import { useTranslation } from 'react-i18next';

const tableColumns = [
  {
    label: 'affiliatesPage.table.affiliateName',
    className: '',
  },
  {
    label: 'affiliatesPage.table.started',
    className: '',
  },
  {
    label: 'affiliatesPage.table.Account',
    className: '',
  },
  {
    label: 'affiliatesPage.table.renewsExpires',
    className: '',
  },
  {
    label: 'affiliatesPage.table.commissionsEarned',
    className: '',
  },
];

type Props = {
  affiliates: Affiliate[];
};

export const AffiliatesTable: React.FC<Props> = ({ affiliates }) => {
  const { t } = useTranslation();

  return (
    <div className="">
      <div className="flex item-center justify-between mb-5">
        <h1 className="text-2xl font-bold mb-4">Affiliates</h1>
        <Button className="min-w-[142px]" size={'lg'} variant={'gradient'}>
          Copy Code
        </Button>
      </div>
      <Card className="bg-card rounded-[20px] p-5">
        <Table>
          <TableHeader className="[&_tr]:border-0">
            <TableRow>
              {tableColumns.map((column) => (
                <TableHead key={column.label} className="w-[200px] font-bold">
                  {t(column.label)}
                </TableHead>
              ))}
            </TableRow>
          </TableHeader>
          <TableBody>
            {affiliates.map((affiliate, index) => (
              <TableRow key={index}>
                <TableCell className={'font-medium'}>
                  {affiliate.name}
                </TableCell>
                <TableCell className={'font-medium'}>
                  {formatDate(affiliate.started)}
                </TableCell>
                <TableCell>
                  <div className="space-y-1 max-w-[135px]">
                    <p className="py-1 px-5 bg-success-light rounded-sm text-[10px] text-success">
                      {affiliate.account}
                    </p>
                    <p className={'font-medium'}>{affiliate.accountNumber}</p>
                  </div>
                </TableCell>
                <TableCell className={'font-medium'}>
                  {formatDate(affiliate.renews)}
                </TableCell>
                <TableCell className={'font-medium'}>
                  {affiliate.commissions}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
};
